// extracted by mini-css-extract-plugin
export default {"root":"_3jR0iket1UXiLCFmAMQfg4"};